module.exports = {
  title: '待付对账单',
  route: {
    path: '/finance-manage',
    children: {
      path: 'reconciliation-wait-paid',
    },
  },
};
